const lifecycleDetails = (invoice = {}) => {
  if (invoice.status === "invoice_posted" || invoice.sap_posting_status_code === "3" || invoice.sap_lifecycle_status_code === "8") {
    return { label: "Posted", className: "border-emerald-300 bg-emerald-100 text-emerald-900" };
  }
  if (invoice.sap_lifecycle_status_code === "1") {
    return { label: "In Process", className: "border-sky-300 bg-sky-100 text-sky-900" };
  }
  if (invoice.sap_lifecycle_status_code === "3") {
    return { label: "Ready for Posting", className: "border-amber-300 bg-amber-100 text-amber-900" };
  }
  if (invoice.status === "sap_draft_grn_linked_review" || invoice.status === "sap_draft_pending_review") {
    return { label: "Draft", className: "border-slate-300 bg-slate-100 text-slate-700" };
  }
  return { label: "SAP status pending", className: "border-slate-300 bg-white text-slate-600" };
};

export const SapLifecycleBadge = ({ invoice, testId }) => {
  if (!invoice?.sap_invoice_id) return null;
  const lifecycle = lifecycleDetails(invoice);
  return <span className={`inline-flex shrink-0 whitespace-nowrap items-center border px-2 py-0.5 text-[10px] font-bold ${lifecycle.className}`} data-testid={testId}>{lifecycle.label}</span>;
};